import baseApi from "./baseApi";
import apiPaths from "./apiPaths";
import { ReportEventCodeSetModel } from "../models/report/ReportEventCodeSetModel";
import { ReportEventCodeModel } from "../models/report/ReportEventCodeModel";
import { ReportEventItemTypeOptionModel } from "../models/report/ReportEventItemTypeOptionModel";

export class eventCodesApi extends baseApi {
    constructor(baseUrl: string, userId: string) {
        super(baseUrl, userId);
    }

    public async getEventCode(eventCodeGuid: string): Promise<ReportEventCodeModel> {
        return await this.Get(apiPaths.getEventCode(eventCodeGuid));
    }

    public async getEventCodes(eventCodeSetGuid: string): Promise<ReportEventCodeModel[]> {
        return await this.Get(apiPaths.getEventCodes(eventCodeSetGuid));
    }

    public async getEventCodeSet(eventCodeSetGuid: string): Promise<ReportEventCodeSetModel> {
        return await this.Get(apiPaths.getEventCodeSet(eventCodeSetGuid));
    }

    public async getEventCodeSets(userGuid: string): Promise<ReportEventCodeSetModel[]> {
        return await this.Get(apiPaths.getEventCodeSets(userGuid));
    }

    public async getEventItemTypeOption(eventItemTypeOptionGuid: string): Promise<ReportEventItemTypeOptionModel> {
        return await this.Get(apiPaths.getEventItemTypeOption(eventItemTypeOptionGuid));
    }

    public async getEventItemTypeOptions(eventCodeSetGuid: string): Promise<ReportEventItemTypeOptionModel[]> {
        return await this.Get(apiPaths.getEventItemTypeOptions(eventCodeSetGuid));
    }
}